import React from 'react';
import { Box, Typography, Avatar, Rating } from '@mui/material';
import SectionContainer from './SectionContainer';
import SectionEyebrow from './SectionEyebrow';
import { testimonials } from './content';

const Testimonials = () => (
  <SectionContainer id="testimonials" sx={{ py: { xs: 6, md: 10 } }}>
    <SectionEyebrow color="#EF4444">Testimonials</SectionEyebrow>
    <Typography variant="h2" sx={{ fontWeight: 700, mb: 5, fontSize: { xs: 24, md: 32 }, maxWidth: 560 }}>
      Loved by teams who used to track everything on spreadsheets
    </Typography>

    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' }, gap: 3 }}>
      {testimonials.map(({ name, role, quote, initials }) => (
        <Box
          key={name}
          sx={(theme) => ({
            p: 3,
            borderRadius: 4,
            border: '1px solid',
            borderColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(15,23,42,0.06)',
            bgcolor: 'background.paper',
          })}
        >
          <Rating value={5} readOnly size="small" sx={{ mb: 1.5 }} />
          <Typography sx={{ color: 'text.secondary', fontSize: 14.5, mb: 2.5 }}>&ldquo;{quote}&rdquo;</Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Avatar sx={{ bgcolor: 'primary.main', fontSize: 14, fontWeight: 700 }}>{initials}</Avatar>
            <Box>
              <Typography sx={{ fontWeight: 600, fontSize: 14 }}>{name}</Typography>
              <Typography sx={{ color: 'text.secondary', fontSize: 12.5 }}>{role}</Typography>
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  </SectionContainer>
);

export default Testimonials;
